import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';

import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { Observable, throwError } from "rxjs";
import { ModalDirective } from "ngx-bootstrap/modal";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseAutoUploaderComponent } from "app/Core/Abstract/baseAutoUploader.component";
import { SecurityService } from "app/Core/Security/security.service";
import { ConfigService } from "app/Core/Abstract/config.service";
import { LogService } from "app/Core/Abstract/log.service";
import { VisualsService } from "app/Core/Abstract/visuals.service";
import { EventsEmitterService } from "app/Core/Abstract/emitter.service";


@Component({
  selector: "inlinefileuploader",
  templateUrl: "inlinefileuploader.component.html",
  styleUrls: ["./inlinefileuploader.component.scss"]
})
export class InlineFileUploaderComponent extends BaseAutoUploaderComponent
  implements OnInit {
  @ViewChild("errorModal",{static: false}) public errorModal: ModalDirective;
  @ViewChild("fileUpload") fileUpload: any;
  @Input() submit: any;
  @Input() status: any;
  @Input() multiple: any;
  @Input() regCmpDocId:any;
  @Input() hasError;
  @Input() disable;
  downloadedTemplate:boolean = false;
  docsList:any;
  private _pk: any;
  

  private _userId = '';

  @Input()
  set userId(name) {
    this._userId = name ;
  }

  get userId() { return this._userId; }
  get pk(): any {
    return this._pk;
  }
  @Input("pk")
  set pk(value: any) {
    this._pk = value;
  
    //clear previous
    this.uploader.clearQueue();
  }

  @Output()
  refresh: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  getDocumentList: EventEmitter<any> = new EventEmitter<any>();

  protected continueWithSearch: boolean = true;
  constructor(
    protected securityService: SecurityService,
    protected configService: ConfigService,
    protected logger: LogService,
    protected visualsService: VisualsService,
    protected eventsEmitterService: EventsEmitterService,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
    super(
      securityService,
      configService,
      logger,
      visualsService,
      eventsEmitterService
    );
    this.getVisuals();
    
    this.docsList = this.visualsService.getLkpFromStorageAsJSON(
      "LKP_REGCMP_DOCUMENT_I_DOC_ID",
      true
    );
    this.eventsEmitterService.languageChange.subscribe(langId => {
      this.getVisuals();
      this.docsList = this.visualsService.getLkpFromStorageAsJSON(
        "LKP_REGCMP_DOCUMENT_I_DOC_ID",
        true
      );
    });
  }

  protected initLoader() {
    this.group = "uploadFiles";
    this.URL = this.configService.getServer() + "FileUploadService/uploadFile";
    this.displayAllowedMimeType = [ "pdf","text","jpeg","png","powerpoint","excel","word"]
    this.allowedMimeType = [
      "application/pdf",
      "text/plain",
      "image/jpeg",
      "image/png",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/vnd.ms-powerpoint",
      "application/msword",
      "application/vnd.ms-excel"
    ];
    this.uploader = new FileUploader({
      url: this.URL,
      authToken:
        "Bearer " + this.securityService.getFromStorage("access_token"),
      allowedMimeType: this.allowedMimeType,
      maxFileSize: this.maxFileSize,
      queueLimit: this.queueLimit
    });
    this.uploader.onBuildItemForm = (item, form) => {
      form.append("docId", encodeURI(this._pk["docId"] ? this._pk["docId"] : null));
      form.append("userId", this._userId);
      if (this._pk["comments"]) {
        form.append("comments", this._pk["comments"]);
      }
    };
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
  }
  onErrorItem(item: FileItem, response: string, status: number, headers: any): any {
    LogService.emitAlert({
      type: "danger",
      body: response
    });

}
  private download(id: number,fileName: string) {
    this.visualsService.downloadFile(id,fileName,this._userId).subscribe(
      data => {
        this.logger.log("Downloaded file");
      },
      error => {
        this.logger.log("Error Dowloading file");
      }
    );
  }

  private downloadTemplate(hasTemplate: string ,templateFileName: string,templateFileExt: string){
    this.visualsService.downloadTemplateFile(hasTemplate,templateFileName,templateFileExt).subscribe(
      response => {
        this.downloadedTemplate = true
        this.logger.log("Error Dowloading Template");
      },
      error => {
        this.logger.log("Error Dowloading Template");
      }
    );
  }

  private deleteFile(regcmpdocId: number) {
    this.visualsService.deleteFile(regcmpdocId).subscribe(
      data => {
        this.logger.log("deleted file");
        this.refresh.emit(regcmpdocId);
      },
      error => {
        this.logger.log("Error deleting file");
      }
    );
  }

  public uploadSuccessCallback() {
    this.refresh.emit();
  }
}
